import logoLogin from '../assets/images/logo_login.png'
import logoMenu from '../assets/images/logo_menu.png'
import loginBackground from '../assets/images/BACKGROUND.png'
import myDocumentImage from '../assets/images/12892987_5106928 1.png'

import { ReactComponent as userNameInput } from '../assets/icons/user.svg'
import { ReactComponent as lockPasswordInput } from '../assets/icons/lock.svg'
import { ReactComponent as eyeOffPasswordInput } from '../assets/icons/off.svg'
import { ReactComponent as eyePasswordInput } from '../assets/icons/eye.svg'
import { ReactComponent as emailInput } from '../assets/icons/mail.svg'
import { ReactComponent as burgerMenu } from '../assets/icons/big.svg'
import { ReactComponent as search } from '../assets/icons/search.svg'
import { ReactComponent as noti } from '../assets/icons/Variant3.svg'
import { ReactComponent as userFill } from '../assets/icons/user fill.svg'
import { ReactComponent as profileDown } from '../assets/icons/down.svg'
import { ReactComponent as chatDrawer } from '../assets/icons/box.svg'
import { ReactComponent as docDrawer } from '../assets/icons/7.svg'
import { ReactComponent as folderDrawer } from '../assets/icons/folder.svg'
import { ReactComponent as barDrawer } from '../assets/icons/bar.svg'
import { ReactComponent as securityDrawer } from '../assets/icons/security.svg'
import { ReactComponent as chartDrawer } from '../assets/icons/chart.svg'
import { ReactComponent as dotMenu } from '../assets/icons/dot menu.svg'
import { ReactComponent as circleButton } from '../assets/icons/circle.svg'
import { ReactComponent as editTable } from '../assets/icons/1.svg'
import { ReactComponent as Building } from '../assets/icons/4.svg'
import { ReactComponent as listFolder } from '../assets/icons/alt.svg'
import { ReactComponent as Folder } from '../assets/icons/closed.svg'
import { ReactComponent as double } from '../assets/icons/double.svg'
import { ReactComponent as file } from '../assets/icons/77.svg'
import { ReactComponent as upDown } from '../assets/icons/ph_caret-up-down-bold.svg'
import { ReactComponent as listFill } from '../assets/icons/list fill.svg'
import { ReactComponent as bMenu } from '../assets/icons/bento menu-1.svg'
import { ReactComponent as security1 } from '../assets/icons/security1.svg'
import { ReactComponent as downloadButton } from '../assets/icons/download.svg'
import { ReactComponent as box1 } from '../assets/icons/box4.svg'
import { ReactComponent as box2 } from '../assets/icons/falt.svg'
import { ReactComponent as box3 } from '../assets/icons/fclosed.svg'
import { ReactComponent as box4 } from '../assets/icons/fdouble.svg'
import { ReactComponent as box5 } from '../assets/icons/f7.svg'
import { ReactComponent as dotMenuV } from '../assets/icons/dot menu v.svg'
import { ReactComponent as addLayer } from '../assets/icons/add layer.svg'
import { ReactComponent as searchFile } from '../assets/icons/seach-file.svg'
import { ReactComponent as checkboxButton } from '../assets/icons/checkbox.svg'
import { ReactComponent as informationButton } from '../assets/icons/information.svg'
import { ReactComponent as iconUpload } from '../assets/icons/bup1.svg'
import { ReactComponent as uploadCloud } from '../assets/icons/feather_upload-cloud.svg'
import { ReactComponent as h_archive } from '../assets/icons/archive.svg'
import { ReactComponent as h_book } from '../assets/icons/book.svg'
import { ReactComponent as sup_trash } from '../assets/icons/trash.svg'
import { ReactComponent as circle_close } from '../assets/icons/circle_close.svg'
import { ReactComponent as bcircle } from '../assets/icons/bcircle.svg'

import iconAddPhoto from '../assets/icons/iconAddPhoto.svg'
import iconTrash from '../assets/icons/iconTrash.svg'
import previoes_slice from '../assets/icons/previous_slice.svg'
import next_slice from '../assets/icons/next_slice.svg'
import meatball from '../assets/icons/meatball'
import dropdownEdit from '../assets/icons/dropdownEdit.svg'
import dropdownTrash from '../assets/icons/dropdownTrash.svg'
import close from '../assets/icons/close.svg'
import print from '../assets/icons/print.svg'
import add from '../assets/icons/add.svg'
import Shuffle from '../assets/icons/shuffle.svg'
import dropdown from '../assets/icons/dropdown.svg'

export const logo = {
    logoLogin: logoLogin,
    logoMenu: logoMenu,
}

export const background = {
    loginBackground: loginBackground,
}

export const imgs = {
    myDocumentImage: myDocumentImage
}

export const icons = {
    userNameInput: userNameInput,
    lockPasswordInput: lockPasswordInput,
    eyePasswordInput: eyePasswordInput,
    eyeOffPasswordInput: eyeOffPasswordInput,
    emailInput: emailInput,
    burgerMenu: burgerMenu,
    search: search,
    noti: noti,
    userFill: userFill,
    profileDown: profileDown,
    chatDrawer: chatDrawer,
    docDrawer: docDrawer,
    folderDrawer: folderDrawer,
    chartDrawer: chartDrawer,
    barDrawer: barDrawer,
    securityDrawer: securityDrawer,
    dotMenu: dotMenu,
    circleButton: circleButton,
    editTable: editTable,
    Building: Building,
    listFolder: listFolder,
    Folder: Folder,
    double: double,
    file: file,
    upDown: upDown,
    listFill: listFill,
    bMenu: bMenu,
    security1: security1,
    downloadButton: downloadButton,
    box1: box1,
    box2: box2,
    box3: box3,
    box4: box4,
    box5: box5,
    dotMenuV: dotMenuV,
    addLayer: addLayer,
    searchFile: searchFile,
    checkboxButton: checkboxButton,
    informationButton: informationButton,
    iconUpload: iconUpload,
    uploadCloud: uploadCloud,
    h_archive: h_archive,
    h_book: h_book,
    sup_trash: sup_trash,
    circle_close: circle_close,
    bcircle: bcircle,

    iconAddPhoto: iconAddPhoto,
    iconTrash: iconTrash,
    previoes_slice: previoes_slice,
    next_slice: next_slice,
    meatball: meatball,
    dropdownEdit: dropdownEdit,
    dropdownTrash: dropdownTrash,
    close: close,
    print: print,
    add: add,
    Shuffle: Shuffle,
    dropdown: dropdown
}
